import React, { useState } from 'react';
import { CustomModal } from '../../../../components';
import { useManageStatus, useUpdateGestorEntryStatus } from '../../../../share';
import { useEntryGestorStatusolicitud } from '../../../../utils/validators/entry-request/entryGestorUpdateValidator';
import { TechnicalStatus } from '../../types/technical-type';
import InventoryDetailView from '../views/InventoryDetailView';
import { InventoryViewAPI } from '../../api/inventoryViewAPI';
import { useFetchTransferById, useFetchTransferByIdItems } from '../../../../hooks';

interface InventoryDetailContainerProps {
  isOpen: boolean;
  OnClose: () => void;
  technicalId?: string;
  onViewDetail: (id: string) => void;
}

const TechnicalConceptDetailContainer: React.FC<InventoryDetailContainerProps> = ({
  isOpen,
  OnClose,
  technicalId,
  onViewDetail,
}) => {
  const [footerLeft, setFooterLeft] = useState<React.ReactNode>(null);
  const { mutateAsync: updateGestorStatus } = useUpdateGestorEntryStatus();
  const { data: entryPetition } = useManageStatus('EntryPetition');

  const { data: detailData, isPending: isLoading } = useFetchTransferById(technicalId);
  const { data: items, isLoading: loadingItems } = useFetchTransferByIdItems(technicalId);

  const onSaveSolicitud = async (values: any) => {
    const token = localStorage.getItem('auth');
    const tokenToJs = token ? JSON.parse(token).authorization.token : null;

    entryPetition?.forEach((item: any) => {
      if (item.id === values.status_id && item.name !== TechnicalStatus.DEVUELTO) {
        formikSolicitud.setFieldValue('rejection_reason', '');
      }
    });

    const body = {
      status_id: values.status_id,
      rejection_reason: values.rejection_reason,
    };

    try {
      await updateGestorStatus({ body, token: tokenToJs, id: Number(detailData?.id) });
      OnClose();
    } catch (error) {
      console.error('Error al actualizar los ítems del gestor:', error);
    }
  };

  const formikSolicitud = useEntryGestorStatusolicitud({ onSubmit: onSaveSolicitud });

  const closeModal = () => {
    formikSolicitud.resetForm();
    OnClose();
  };

  const handleDownloadDocuments = async (ids: string[]) => {
    if (!technicalId) return;

    try {
      await InventoryViewAPI.downloadConceptDocuments(technicalId);
    } catch (error) {
      console.error('Error al descargar documentos:', error);
    }
  };

  return (
    <CustomModal
      title={`Detalle traslados entre funcionarios - ${detailData?.ticket || 'N/A'}`}
      open={isOpen}
      width="95vw"
      onCancel={closeModal}
      isLoading={isLoading}
      footerLeft={footerLeft}
      onSave={formikSolicitud.handleSubmit}
      labelCancel="Finalizar"

    >
      <InventoryDetailView
        detailData={detailData}
        setFooterLeft={setFooterLeft}
        onDocuments={handleDownloadDocuments}
        entryStates={entryPetition}
        formikSolicitud={formikSolicitud}
        onViewDetail={onViewDetail}
        dataItems={items}
        isLoadingItems={loadingItems}
      />
    </CustomModal>
  );
};

export default TechnicalConceptDetailContainer;